export const singleTimezoneCountries = {
  AD: "+1",      // Andorra
  AE: "+4",      // United Arab Emirates
  AF: "+4:30",   // Afghanistan
  AG: "-4",      // Antigua and Barbuda
  AI: "-4",      // Anguilla
  AL: "+1",      // Albania
  AM: "+4",      // Armenia
  AO: "+1",      // Angola
  AR: "-3",      // Argentina
  AS: "-11",     // American Samoa
  AT: "+1",      // Austria
  AW: "-4",      // Aruba
  AX: "+2",      // Aland Islands
  AZ: "+4",      // Azerbaijan
  BA: "+1",      // Bosnia & Herzegovina
  BB: "-4",      // Barbados
  BD: "+6",      // Bangladesh
  BE: "+1",      // Belgium
  BF: "0",       // Burkina Faso
  BG: "+2",      // Bulgaria
  BH: "+3",      // Bahrain
  BI: "+2",      // Burundi
  BJ: "+1",      // Benin
  BL: "-4",      // Saint Barthelemy
  BM: "-4",      // Bermuda
  BN: "+8",      // Brunei
  BO: "-4",      // Bolivia
  BQ: "-4",      // Bonaire, Sint Eustatius and Saba
  BS: "-5",      // Bahamas
  BT: "+6",      // Bhutan
  BW: "+2",      // Botswana
  BY: "+3",      // Belarus
  BZ: "-6",      // Belize
  CC: "+6:30",   // Cocos (Keeling) Islands
  CF: "+1",      // Central African Republic
  CG: "+1",      // Republic of the Congo
  CH: "+1",      // Switzerland
  CI: "0",       // Ivory Coast
  CK: "-10",     // Cook Islands
  CM: "+1",      // Cameroon
  CN: "+8",      // China (officially uses one timezone)
  CO: "-5",      // Colombia
  CR: "-6",      // Costa Rica
  CU: "-5",      // Cuba
  CV: "-1",      // Cape Verde
  CW: "-4",      // Curaçao
  CX: "+7",      // Christmas Island
  CY: "+2",      // Cyprus
  CZ: "+1",      // Czech Republic
  DE: "+1",      // Germany
  DJ: "+3",      // Djibouti
  DK: "+1",      // Denmark (Greenland & Faroe Islands are separate codes)
  DM: "-4",      // Dominica
  DO: "-4",      // Dominican Republic
  DZ: "+1",      // Algeria
  EE: "+2",      // Estonia
  EG: "+2",      // Egypt
  EH: "0",       // Western Sahara (disputed, but commonly UTC+0)
  ER: "+3",      // Eritrea
  ES: "+1",      // Spain (mainland only, ignoring Canary Islands)
  ET: "+3",      // Ethiopia
  FI: "+2",      // Finland (Åland is separate code AX)
  FJ: "+12",     // Fiji
  FK: "-3",      // Falkland Islands
  FO: "0",       // Faroe Islands
  FR: "+1",      // France (mainland only, overseas have separate codes)
  GA: "+1",      // Gabon
  GB: "0",       // UK (overseas are separate codes)
  GD: "-4",      // Grenada
  GE: "+4",      // Georgia
  GF: "-3",      // French Guiana
  GG: "0",       // Guernsey
  GH: "0",       // Ghana
  GI: "+1",      // Gibraltar
  GM: "0",       // Gambia
  GN: "0",       // Guinea
  GP: "-4",      // Guadeloupe
  GQ: "+1",      // Equatorial Guinea
  GR: "+2",      // Greece
  GS: "-2",      // South Georgia & South Sandwich Islands
  GT: "-6",      // Guatemala
  GU: "+10",     // Guam
  GW: "0",       // Guinea-Bissau
  GY: "-4",      // Guyana
  HK: "+8",      // Hong Kong
  HN: "-6",      // Honduras
  HR: "+1",      // Croatia
  HT: "-5",      // Haiti
  HU: "+1",      // Hungary
  IE: "0",       // Ireland
  IL: "+2",      // Israel
  IM: "0",       // Isle of Man
  IN: "+5:30",   // India
  IO: "+6",      // British Indian Ocean Territory
  IQ: "+3",      // Iraq
  IR: "+3:30",   // Iran
  IS: "0",       // Iceland
  IT: "+1",      // Italy
  JE: "0",       // Jersey
  JM: "-5",      // Jamaica
  JO: "+2",      // Jordan
  JP: "+9",      // Japan
  KE: "+3",      // Kenya
  KG: "+6",      // Kyrgyzstan
  KH: "+7",      // Cambodia
  KM: "+3",      // Comoros
  KN: "-4",      // St. Kitts & Nevis
  KP: "+9",      // North Korea
  KR: "+9",      // South Korea
  KW: "+3",      // Kuwait
  KY: "-5",      // Cayman Islands
  LA: "+7",      // Laos
  LB: "+2",      // Lebanon
  LC: "-4",      // St. Lucia
  LI: "+1",      // Liechtenstein
  LK: "+5:30",   // Sri Lanka
  LR: "0",       // Liberia
  LS: "+2",      // Lesotho
  LT: "+2",      // Lithuania
  LU: "+1",      // Luxembourg
  LV: "+2",      // Latvia
  LY: "+2",      // Libya
  MA: "+1",      // Morocco
  MC: "+1",      // Monaco
  MD: "+2",      // Moldova
  ME: "+1",      // Montenegro
  MF: "-4",      // Saint Martin
  MG: "+3",      // Madagascar
  MH: "+12",     // Marshall Islands (all on UTC+12)
  MK: "+1",      // North Macedonia
  ML: "0",       // Mali
  MM: "+6:30",   // Myanmar
  MO: "+8",      // Macau
  MP: "+10",     // Northern Mariana Islands
  MQ: "-4",      // Martinique
  MR: "0",       // Mauritania
  MS: "-4",      // Montserrat
  MT: "+1",      // Malta
  MU: "+4",      // Mauritius
  MV: "+5",      // Maldives
  MW: "+2",      // Malawi
  MY: "+8",      // Malaysia (single official time zone)
  MZ: "+2",      // Mozambique
  NA: "+2",      // Namibia
  NC: "+11",     // New Caledonia
  NE: "+1",      // Niger
  NF: "+11:30",  // Norfolk Island
  NG: "+1",      // Nigeria
  NI: "-6",      // Nicaragua
  NL: "+1",      // Netherlands (overseas have separate codes)
  NO: "+1",      // Norway (Svalbard & Jan Mayen separate code)
  NP: "+5:45",   // Nepal
  NR: "+12",     // Nauru
  NU: "-11",     // Niue
  OM: "+4",      // Oman
  PA: "-5",      // Panama
  PE: "-5",      // Peru
  PH: "+8",      // Philippines
  PK: "+5",      // Pakistan
  PL: "+1",      // Poland
  PM: "-3",      // Saint Pierre and Miquelon
  PN: "-8",      // Pitcairn
  PR: "-4",      // Puerto Rico
  PS: "+2",      // Palestine
  PW: "+9",      // Palau
  PY: "-4",      // Paraguay
  QA: "+3",      // Qatar
  RE: "+4",      // Réunion
  RO: "+2",      // Romania
  RS: "+1",      // Serbia
  RW: "+2",      // Rwanda
  SA: "+3",      // Saudi Arabia
  SB: "+11",     // Solomon Islands
  SC: "+4",      // Seychelles
  SD: "+2",      // Sudan
  SE: "+1",      // Sweden
  SG: "+8",      // Singapore
  SH: "0",       // Saint Helena
  SI: "+1",      // Slovenia
  SJ: "+1",      // Svalbard & Jan Mayen
  SK: "+1",      // Slovakia
  SL: "0",       // Sierra Leone
  SM: "+1",      // San Marino
  SN: "0",       // Senegal
  SO: "+3",      // Somalia
  SR: "-3",      // Suriname
  SS: "+2",      // South Sudan
  ST: "0",       // Sao Tome and Principe
  SV: "-6",      // El Salvador
  SX: "-4",      // Sint Maarten
  SY: "+2",      // Syria
  SZ: "+2",      // Eswatini
  TC: "-5",      // Turks and Caicos Islands
  TD: "+1",      // Chad
  TG: "0",       // Togo
  TH: "+7",      // Thailand
  TJ: "+5",      // Tajikistan
  TK: "+13",     // Tokelau
  TL: "+9",      // East Timor
  TM: "+5",      // Turkmenistan
  TN: "+1",      // Tunisia
  TO: "+13",     // Tonga
  TR: "+3",      // Turkey
  TT: "-4",      // Trinidad and Tobago
  TV: "+12",     // Tuvalu
  TW: "+8",      // Taiwan
  TZ: "+3",      // Tanzania
  UA: "+2",      // Ukraine
  UG: "+3",      // Uganda
  UY: "-3",      // Uruguay
  UZ: "+5",      // Uzbekistan
  VA: "+1",      // Vatican City
  VC: "-4",      // St. Vincent & Grenadines
  VE: "-4",      // Venezuela
  VG: "-4",      // British Virgin Islands
  VI: "-4",      // U.S. Virgin Islands
  VN: "+7",      // Vietnam
  VU: "+11",     // Vanuatu
  WF: "+12",     // Wallis and Futuna
  WS: "+13",     // Samoa
  YE: "+3",      // Yemen
  YT: "+3",      // Mayotte
  ZA: "+2",      // South Africa
  ZM: "+2",      // Zambia
  ZW: "+2"       // Zimbabwe
};

export const multipleTimezoneCountries = [
  "AQ", // Antarctica (many stations, multiple offsets)
  "AU", // Australia
  "BR", // Brazil
  "CA", // Canada
  "CD", // DR Congo (at least two official local times)
  "CL", // Chile (mainland + Easter Island)
  "EC", // Ecuador (mainland + Galapagos)
  "FM", // Micronesia
  "GL", // Greenland
  "ID", // Indonesia
  "KI", // Kiribati
  "KZ", // Kazakhstan
  "MN", // Mongolia (western provinces differ)
  "MX", // Mexico
  "NZ", // New Zealand (Chatham Islands differ)
  "PF", // French Polynesia (several scattered archipelagos)
  "PG", // Papua New Guinea (Bougainville differs)
  "PT", // Portugal (mainland + Azores)
  "RU", // Russia
  "TF", // French Southern Territories (scattered islands)
  "UM", // U.S. Minor Outlying Islands
  "US"  // United States
];